import { useLocalization } from '@/hooks/use-localization';
import { SliderInput } from '@/isomorphic/components/forms/components/slider-input';
import { FormSlider } from '@/isomorphic/components/forms/components/form-slider';
import { SavingsCalculatorSelectorProps } from './savings-calculator';

export const MonthlySavings = ({ state, updateState, ...props }: SavingsCalculatorSelectorProps) => {
    const { getCurrencySymbol, localize } = useLocalization();

    const formatNumber = (n: number) => n.toLocaleString('sv-SE');

    const getRangeDescription = (min: number, max: number) => {
        return localize('input-range-description').replace('{min}', formatNumber(min)).replace('{max}', formatNumber(max));
    };

    const currencySuffix = getCurrencySymbol();
    const yearSuffix = localize('year').toLowerCase();

    return (
        <>
            <fieldset className="r-m-0 r-flex r-flex-col r-border-none r-p-0">
                <legend className="r-sr-only">
                    {props.monthlySavingsAmountLabel} - {localize('input-slider-group-description')}
                </legend>
                <SliderInput
                    label={props.monthlySavingsAmountLabel}
                    suffix={currencySuffix}
                    min={props.monthlySavingsMinAmount}
                    max={props.monthlySavingsMaxAmount}
                    value={state.monthlySavingsAmount}
                    onChange={value => updateState({ monthlySavingsAmount: value })}
                    formatNumber={formatNumber}
                    rangeDescription={getRangeDescription(props.monthlySavingsMinAmount, props.monthlySavingsMaxAmount)}
                />
                <FormSlider
                    label={props.monthlySavingsAmountLabel}
                    suffix={currencySuffix}
                    step={props.monthlySavingsStepAmount}
                    min={props.monthlySavingsMinAmount}
                    max={props.monthlySavingsMaxAmount}
                    value={state.monthlySavingsAmount}
                    onChange={value => updateState({ monthlySavingsAmount: value })}
                    formatNumber={formatNumber}
                />
            </fieldset>
            <fieldset className="r-m-0 r-flex r-flex-col r-border-none r-p-0">
                <legend className="r-sr-only">
                    {props.monthlySavingsYearLabel} - {localize('input-slider-group-description')}
                </legend>
                <SliderInput
                    label={props.monthlySavingsYearLabel}
                    suffix={yearSuffix}
                    min={props.monthlySavingsMinYear}
                    max={props.monthlySavingsMaxYear}
                    value={state.monthlySavingsYear}
                    onChange={value => updateState({ monthlySavingsYear: value })}
                    formatNumber={formatNumber}
                    rangeDescription={getRangeDescription(props.monthlySavingsMinYear, props.monthlySavingsMaxYear)}
                />
                <FormSlider
                    label={props.monthlySavingsYearLabel}
                    suffix={yearSuffix}
                    step={props.goalSavingsStepYear}
                    min={props.monthlySavingsMinYear}
                    max={props.monthlySavingsMaxYear}
                    value={state.monthlySavingsYear}
                    onChange={value => updateState({ monthlySavingsYear: value })}
                    formatNumber={formatNumber}
                />
            </fieldset>
        </>
    );
};
